<template>
    <div class="my-10">
        <Modal :show-modal="addressModal" @cancel="closeAddressModal">
            <template v-slot:header>
                <p class="text-3xl font-bold text-main-color">{{ onEdit ? $t('page.editAddress') : $t('page.addAddress') }}</p>
            </template>
            <template v-slot:content>
                <div class="flex flex-col">
                    <Form @submit="postAddress(onEdit ? 'edit' : 'add', selectedAddress.id)" :validation-schema="addressSchema()">
                        <div class="mt-5 flex flex-col gap-2">
                            <label for="name" class="text-start font-semibold text-main-color">{{ $t('page.name')
                                }}</label>
                            <Field v-model="formAddress.name"  name="name" id="name" 
                                class="w-full rounded border px-8 py-5 placeholder-[#5F5F5F] resize-none max-md:py-4">
                            </Field>
                            <ErrorMessage name="name" class="text-red-500"></ErrorMessage>
                        </div>
                   
                        <div class="mt-5 flex flex-col gap-2">
                            <label for="phone" class="text-start font-semibold text-main-color">{{ $t('form.phone')
                                }}</label>
                            <Field v-model="formAddress.phone"  name="phone" id="phone" 
                                class="w-full rounded border px-8 py-5 placeholder-[#5F5F5F] resize-none max-md:py-4">
                            </Field>
                            <ErrorMessage name="phone" class="text-red-500"></ErrorMessage>
                        </div>
                   
                        <div class="mt-5 flex flex-col gap-2">
                            <label for="address" class="text-start font-semibold text-main-color">{{ $t('form.address')
                                }}</label>
                            <Field v-model="formAddress.address"  name="address" id="address" 
                                class="w-full rounded border px-8 py-5 placeholder-[#5F5F5F] resize-none max-md:py-4">
                            </Field>
                            <ErrorMessage name="address" class="text-red-500"></ErrorMessage>
                        </div>

                        <div class="mt-5 flex gap-5">
                            <SubmitBtn type="submit" :loading="loading">{{ onEdit ? $t('page.editAddress') : $t('page.addAddress') }}</SubmitBtn>
                            <button @click="closeAddressModal" class="w-full text-main-color font-bold">{{ $t('action.cancel') }}</button>
                        </div>
                    </Form>
                </div>
            </template>
        </Modal>
        <div class="flex flex-col">
            <div class="mb-4 flex items-center justify-between bg-white rounded p-3">

                <h1 class="font-bold text-2xl">{{ $t('nav.addresses') }}</h1>
          
                <button @click="openAddressModal"
                class="ml-auto font-semibold text-white py-2.5 px-4 rounded cursor-pointer bg-main-color hover:bg-accent-color md:mb-0 md:mr-3">
                {{ $t('page.addAddress') }}</button>
            </div>
            <div class="w-full flex flex-col gap-5">
                <div class="w-full flex flex-col gap-2">
                    <div class="grid grid-cols-6 bg-white p-3 rounded">
                        <div class="col-span-5 flex items-center justify-between">
                            <p class="w-full font-bold">{{ $t('page.name') }}</p>
                            <p class="w-full font-bold">{{ $t('form.phone') }}</p>
                            <p class="w-full font-bold">{{ $t('form.address') }}</p>
                        </div>
                        <div class="col-span-1"></div>
                    </div>
                    <AddressCard @edit="beforeEditAddress" @delete="deleteAddress" v-for="address in addresses" :key="address?.id" :detail="address">

                    </AddressCard>
                </div>
                <div v-show="loading === true" class="flex justify-center mx-auto w-full" role="status">
                    <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin  fill-main-color">
                    </IconSpinner>

                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <div class="mt-5" v-show="addresses.length === 0 && loading === false">
                <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.not_found') }}</p>
            </div>


        </div>

    </div>
</template>
<script>
import api from '@/api';
import AddressCard from "@cmp/profile/AddressCard.vue";
import Modal from "@cmp/Modal.vue";
import { Field, Form, ErrorMessage } from 'vee-validate';
import { i18n } from '@/i18n'
import { addressSchema } from "@/schemas";

export default {
    name: '',
    components: {
        AddressCard,
        Modal,
        Field, Form, ErrorMessage

    },
    data() {
        return {
            loading: false,
            addresses: [],
            addressSchema: addressSchema,
            addressModal: false,
            onEdit: false,
            selectedAddress: null,
            formAddress: {
                name: null,
                phone: null,
                address: null
            }
        }
    },
    methods: {
        openAddressModal() {
           
            this.addressModal = true
        },
        closeAddressModal() {
            this.addressModal = false
            this.formAddress = {
                name: null,
                phone: null,
                address: null
            }
            this.onEdit = false
            this.selectedAddress = null


        },
        async getAddresses() {
            this.loading = true
            try {
                const response = await api.get('users/contacts/')
                this.addresses = response.data
            } catch (e) {
                console.log(e)
            }
            this.loading = false

        },
        async postAddress(action, id=null){
            this.loading = true
            if (action == 'add'){
                try {
                    const response = await api.post(`users/contacts/`, this.formAddress)
                    await this.getAddresses()
                    this.$toast.info(i18n.global.t('warning.ADDRESS_ADDED'))
                    this.closeAddressModal()
                }catch (e){
                    console.log(e)
                }
            }
            else{
                try {
                    const response = await api.patch(`users/contacts/${id}/`, this.formAddress)
                    await this.getAddresses()
                    this.$toast.info(i18n.global.t('warning.ADDRESS_UPDATED'))
                    this.closeAddressModal()
                }catch (e){
                    console.log(e)
                }

            }
            
            this.loading = false

        },
        beforeEditAddress(id){
            this.selectedAddress = this.addresses.filter(el => el.id == id)[0]
            this.onEdit = true

            this.formAddress = {
                name: this.selectedAddress.name,
                phone: this.selectedAddress.phone,
                address: this.selectedAddress.address,
            }
            this.openAddressModal()
        },
       
        async deleteAddress(id){
            this.loading = true

            try {
                const response = await api.delete(`users/contacts/${id}/`)
                await this.getAddresses()
                this.$toast.info(i18n.global.t('warning.ADDRESS_DELETED'))
            }catch (e){
                console.log(e)
            }
            this.loading = false

        },
    },
    computed: {},
    created() {
        this.getAddresses()
    }
}

</script>